import { FC, useState, useEffect, useRef, useCallback, ReactNode } from 'react'
import {
  Box,
  Grid,
  Tabs,
  Tab,
  Popover,
  List,
  ListItem,
  Button,
} from '@mui/material'

// Components
import { SlipsScreenType, TabPanel, TabsEnums } from '../../../components'
import {
  AllItemComponent,
  OutItemComponent,
  LeftItemComponent,
  InItemComponent,
} from '.'

// Redux
import { useAppDispatch, useAppSelector } from '../../../hooks'
import {
  fetchSlipsListAction,
  fetchSlipsResetAction,
} from '../../../store/slips'
import { useLocation, useNavigate, useParams } from 'react-router'
import { PaymentItemComponent } from './PaymentItemComponent'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import { getBillTillTodayPDFAction, getBillTillTodayPDFResetAction, getSlipPDFAction, getSlipPDFResetAction, getSiteChallansPDFAction, getSiteChallansExcelAction } from '../../../store/items'
import { showAlertAction } from '../../../store/alerts'
import { AddEditPaymentItem } from './AddEditPayment'
import PageContainerWrapper from '../../../components/PageContainerWrapper'
import PageTitleWrapper from '../../../components/PageTitleWrapper'
import SlipPageHeader from './PageHeader'
import { AddAccountItem } from '../CurrentAccounts/AddNewAccountItem'
import { SlipsOpenEditSiteContext } from './SlipsOpenEditSiteContext'
import {
  getBalanceItemsCheckBoxValue,
  getFormattedEndDateString,
  getFormattedStartDateString,
  getSlipsCheckBoxValue,
} from '../../../utils'
import { BillPDFRequest, SlipData, SlipPDFRequest } from 'src/services'
import MonthlyBills from '../MonthlyBills'
import Ledger from '../Ledger'
import { AccountActionBar } from './AccountActionsBar'
import { EmptyWithAddButton } from '../../../components/Empty/EmptyWithAddButton'
import IssueMoreItem from '../CurrentAccounts/IssueMoreItem'
import SubmitItem from '../CurrentAccounts/SubmitItem'
import hotkeys from 'hotkeys-js'
import { getSlipsLabels } from './slipsLabels'
import SiteRatesTab from './SiteRatesTab'
import EditSiteView from './EditSiteView'
import { SiteActivitiesTab } from './siteActivities'

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const getslipDataToShow = (
  searchTerm,
  searchResults: SlipData,
  data: SlipData
) => (searchTerm?.length > 0 ? searchResults : data)

export interface ViewSlipsProps {
  children?: React.ReactNode
}
export const tabBarColor = '#2e5a88'
export const tabBarTextColor = 'white'

const ViewSlips: FC<ViewSlipsProps> = ({}) => {
  const { bill_id, customer_id } = useParams()
  const { screen_type } = useParams()
  const { search } = useLocation()
  const location = useLocation()
  const navigate = useNavigate();

  const dispatchAction = useAppDispatch()
  const query = new URLSearchParams(search)
  const defaultTabIndex = query ? Number(query.get('tab_index')) : 0

  const [checked, setChecked] = useState<boolean>(getSlipsCheckBoxValue())
  const [balanceItemsChecked, setBalanceItemsChecked] = useState<boolean>(
    getBalanceItemsCheckBoxValue()
  )
  
  const { data: userData } = useAppSelector((state) => state.userData)
  const canViewSiteActivities =
    userData?.userType === 'ADMIN' ||
    userData?.mobile === '+918989898989'

  useEffect(() => {
    const query = new URLSearchParams(location.search)
    let tab = query ? Number(query.get('tab_index')) : 0
    if (tab === 9 && !canViewSiteActivities) {
      tab = 0
    }
    query.delete("tab_index")
    setValue(tab)
  }, [location.search, canViewSiteActivities])
  const {
    data,
    searchResults,
    searchTerm,
    loading: manageSlipsLoading,
    error: manageSlipsError,
    message: slipsLoadErrorMessage,
    success: manageSlipsSuccess,
  } = useAppSelector((state) => state.manageSlips)

  const {
    list: { data: customerAccounts },
  } = useAppSelector((state) => state.manageCustomerAccounts)

  const {
    data: slipPdfLink,
    success: getPDFSuccess,
    error: getPDFError,
    message,
  } = useAppSelector((state) => state.slipPDF)

  const [value, setValue] = useState(0)
  const ref = useRef<any>(null)
  const [showMore, setShowMore] = useState<boolean>(false)
  const [issueMoreItem, setIssueMoreItem] = useState<boolean>(false)
  const [submitItem, setSubmitItem] = useState<boolean>(false)
  const [editSiteDialogOpen, setEditSiteDialogOpen] = useState(false)

  const [selectScreenType, setSelectedScreenType] = useState<SlipsScreenType>(
    SlipsScreenType.Account
  )
  const [subheaderInfo, setSubheaderInfo] = useState<string | ReactNode>('')

  const [editItem, openEditItem] = useState<boolean>(false)
  const [dailyEntryDate, setDailyEntryDate] = useState(null)

  const [emptyResult, setEmptyResult] = useState<boolean>(true)

  type EmptyItem = {
    buttonTitle?: string
    message?: string
    callBack?: () => void
  }

  const slipsLabels = getSlipsLabels(data?.accountInfo?.accountType)
  const TITLE_ADD_PAYMENT = slipsLabels.paymentButtonTitle

  const emptyItemMap = {
    0: {
      buttonTitle: `${slipsLabels.issueButtonTitle} ITEMS`,
      message:
        slipsLabels.issueButtonTitle === 'Hire'
          ? 'You have not taken any item in this account yet. Click this button to take items.'
          : 'You have not issued any item in this account yet. Click this button to issue items.',
    },
    1: {
      buttonTitle: `${slipsLabels.issueButtonTitle} ITEMS`,
      message:
        slipsLabels.issueButtonTitle === 'Hire'
          ? 'You have not taken any item in this account yet. Click this button to take items.'
          : 'You have not issued any item in this account yet. Click this button to issue items.',
    },
    2: {
      buttonTitle: `${slipsLabels.receiveButtonTitle} ITEMS`,
      message:
        slipsLabels.receiveButtonTitle === 'Return'
          ? 'You have not returned any item in this account yet. Click this button to return items.'
          : 'You have not received any item in this account yet. Click this button to receive items.',
    },
    3: {
      buttonTitle: `${slipsLabels.issueButtonTitle} ITEMS`,
      message:
        slipsLabels.issueButtonTitle === 'Hire'
          ? 'You have not taken any item in this account yet. Click this button to take items.'
          : 'You have not issued any item in this account yet. Click this button to issue items.',
    },
    4: {
      buttonTitle: slipsLabels.paymentButtonTitle,
      message:
        'No payment entry has been found in this account. Click this button to add payment entry.',
    },
  }

  useEffect(() => {
    if (value === 9 && !canViewSiteActivities) {
      setValue(0)
    }
  }, [value, canViewSiteActivities])

  useEffect(() => {
    if (data) {
      if (value === 0) {
        setEmptyResult(data.all && data.all.length === 0)
      } else if (value === 1) {
        setEmptyResult(data.out && data.out.length === 0)
      } else if (value === 2) {
        setEmptyResult(data.in && data.in.length === 0)
      } else if (value === 3) {
        setEmptyResult(data.left && data.left.length === 0)
      } else if (value === 4) {
        setEmptyResult(data.payment && data.payment.length === 0)
      } else if (value === 5 || value === 6 || value === 7 || value === 8 || value === 9) {
        setEmptyResult(false)
      } else {
        setEmptyResult(true)
      }
    } else {
      setEmptyResult(true)
    }
  }, [data, value])

  useEffect(() => {
     setEmptyResult(true)
  },[])

  useEffect(() => {
    return () => {
      dispatchAction(getSlipPDFResetAction()) // To manage the Alert
      dispatchAction(fetchSlipsResetAction())
      dispatchAction(getBillTillTodayPDFResetAction())
      setEmptyResult(true)
    }
    
  }, [])

  const addPaymentRequest = {
    billId: Number(bill_id),
    paymentId: null,
    amount: null,
    paymentDate: null,
    note: null,
  }

  /** Re-fetch entries/v5 after inline edits so every tab stays in sync (no full-page reload). */
  const silentRefreshSlips = useCallback(() => {
    if (selectScreenType === SlipsScreenType.Date && dailyEntryDate) {
      dispatchAction(
        fetchSlipsListAction(
          0,
          getFormattedStartDateString(dailyEntryDate),
          getFormattedEndDateString(dailyEntryDate)
        )
      )
    } else if (bill_id) {
      dispatchAction(fetchSlipsListAction(bill_id))
    }
  }, [bill_id, selectScreenType, dailyEntryDate, dispatchAction])

  const openEditSite = useCallback(() => {
    setEditSiteDialogOpen(true)
  }, [])

  const handleTabChange = (event, newValue) => {
    setValue(newValue)
    const params = new URLSearchParams(location.search);
    params.set('tab_index', String(newValue));
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  }

  useEffect(() => {
    const type =
      screen_type === 'DATE'
        ? SlipsScreenType.Date
        : screen_type === 'Stock'
        ? SlipsScreenType.Stock
        : SlipsScreenType.Account
    setSelectedScreenType(type)
    if (type === SlipsScreenType.Date) {
      onDateSelect(new Date())
    } else if (bill_id) {
      dispatchAction(fetchSlipsListAction(bill_id))
      window.scrollTo({ behavior: 'smooth', top: 0 })
    }
    if (defaultTabIndex && defaultTabIndex > 0) {
      setValue(defaultTabIndex)
    }
  }, [bill_id, dispatchAction])

  const onDateSelect = (newDate: Date) => {
    setDailyEntryDate(newDate)
    dispatchAction(
      fetchSlipsListAction(
        0,
        getFormattedStartDateString(newDate),
        getFormattedEndDateString(newDate)
      )
    )
  }

  const handleViewPDF = (
    showRate?: boolean | null,
    title?: string,
    challanId?: number,
    showOnlyGoodValue?: boolean
  ) => {
    const slipType =
      value === 0
        ? TabsEnums.All
        : value === 1
        ? TabsEnums.Out
        : value === 2
        ? TabsEnums.In
        : value === 3
        ? "REST"
        : value === 4
        ? TabsEnums.Payment
        : value === 5
        ? TabsEnums.Rates
        : value === 6
        ? TabsEnums.MonthlyBills
        : value === 7
        ? TabsEnums.Ledger
        : TabsEnums.All

    let getPDFRequest: SlipPDFRequest = {
      billId: Number(bill_id),
      showRate: showRate === true,
      showGoodsValue: showRate === null,
      showOnlyGoodValue: showOnlyGoodValue === true,
      slipType: `${slipType}`,
      isRojnamcha: false,
      from: null,
      to: null,
      challanId: challanId,
      hideTotalEntries: getSlipsCheckBoxValue()
    }

    if (screen_type === SlipsScreenType.Date) {
      getPDFRequest = {
        billId: Number(bill_id),
        showRate: showRate === true,
        showGoodsValue: showRate === null,
        showOnlyGoodValue: showOnlyGoodValue === true,
        isRojnamcha: true,
        from: getFormattedStartDateString(dailyEntryDate, false),
        to: getFormattedEndDateString(dailyEntryDate, false),
        slipType: `${slipType}`,
        title: title,
        hideTotalEntries: getSlipsCheckBoxValue()
      }
    }
    dispatchAction(getSlipPDFAction(getPDFRequest))
  }

  useEffect(() => {
    if (!manageSlipsSuccess && slipsLoadErrorMessage) {
      dispatchAction(showAlertAction({ message: slipsLoadErrorMessage, severity: 'error' }))
    } 
  }, [manageSlipsSuccess, slipsLoadErrorMessage])

  useEffect(() => {
    if (getPDFSuccess) {
      window.open(slipPdfLink, '_blank')
    } else if (getPDFError && message) {
      dispatchAction(showAlertAction({ message: message, severity: 'error' }))
    }
  }, [getPDFSuccess, getPDFError, message])

  useEffect(() => {
    if (
      customerAccounts?.length > 0 &&
      bill_id &&
      selectScreenType === SlipsScreenType.Account
    ) {
      const billData = customerAccounts.find((account) => account.id == bill_id)
      console.log({ billData })
      const title = billData?.customer?.name ?? ''
      setSubheaderInfo(title)
    } else {
      setSubheaderInfo("")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bill_id])

  useEffect(() => {
    if (
      data &&
      selectScreenType === SlipsScreenType.Account && data.accountInfo
    ) {
      const billData = data.accountInfo
      const title = billData?.customer?.name ?? ''
      setSubheaderInfo(title)
    } else {
      setSubheaderInfo("")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <SlipsOpenEditSiteContext.Provider value={openEditSite}>
      <>
        <PageTitleWrapper>
          <SlipPageHeader
            onDateSelect={onDateSelect}
            screenType={selectScreenType}
            subheaderInfo={subheaderInfo}
            bill={data?.accountInfo}
            disableEditSite={value === 8}
            onEditSiteClick={openEditSite}
          />
        </PageTitleWrapper>
      <PageContainerWrapper>
        <Grid
          container
          direction="row"
          alignItems="stretch"
          spacing={0}
          sx={{ padding: 0 }}
        >
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
              height: 'calc(100vh - 200px)',
            }}
          >
            <Box
              sx={{
                position: 'sticky',
                top: '100px',
                zIndex: 1000,
                backgroundColor: 'white',
                flexShrink: 0,
              }}
            >
              <Tabs
                id="slips_tab_container"
                defaultValue={0}
                value={value}
                onChange={handleTabChange}
                aria-label="Slips"
                sx={{ backgroundColor: slipsLabels.tabBarBgColor, color: slipsLabels.tabBarTextColor }}
                textColor="inherit"
                TabIndicatorProps={{
                  style: {
                    transition: 'none',
                    backgroundColor: '#ff9800',
                    height: 4,
                  },
                }}
              >
              <Tab label={TabsEnums.All} {...a11yProps(0)} id="id_tab_all" />
              <Tab label={slipsLabels.tabOutLabel} {...a11yProps(1)} id="id_tab_out" />
              <Tab label={slipsLabels.tabInLabel} {...a11yProps(2)} id="id_tab_in" />
              {(selectScreenType === SlipsScreenType.Account ||  selectScreenType === SlipsScreenType.Date) && (
               <Tab
               label={TabsEnums.Left}
               {...a11yProps(3)}
               id="id_tab_left"
               disabled={selectScreenType === SlipsScreenType.Date}
               sx={{
                 '&.Mui-disabled': {
                   color: 'gray',
                   textDecoration: 'line-through', // add this for strike-through
                 },
               }}
             />
             
              )}
              {(selectScreenType === SlipsScreenType.Account || selectScreenType === SlipsScreenType.Date) && (
                <Tab
                  id="id_tab_payment"
                  label={TabsEnums.Payment}
                  {...a11yProps(4)}
                  sx={{ width: 120 }}
                />
              )}
              {selectScreenType === SlipsScreenType.Account && (
                <Tab label="Rates" {...a11yProps(5)} id="id_tab_rates" data-cy="id_tab_rates" />
              )}
              {selectScreenType === SlipsScreenType.Account && (
                <Tab label={TabsEnums.MonthlyBills} {...a11yProps(6)} id="id_tab_bills" data-cy="id_tab_bills" />
              )}
              {selectScreenType === SlipsScreenType.Account && (
                  <Tab label={TabsEnums.Ledger} {...a11yProps(7)} id="id_tab_ledger" data-cy="id_tab_ledger" />
                )}
              {selectScreenType === SlipsScreenType.Account && (
                <Tab label="Site Info" {...a11yProps(8)} id="id_tab_site_info" data-cy="id_tab_site_info" />
              )}
              {selectScreenType === SlipsScreenType.Account &&
                canViewSiteActivities && (
                <Tab label="Activities" {...a11yProps(9)} id="id_tab_activities" data-cy="id_tab_activities" />
              )}
            </Tabs>
            </Box>
            {value < 5 && emptyResult && !manageSlipsLoading && (
              <EmptyWithAddButton
                onClickAdd={(title) => {
                  if (value === 0 || value === 1 || value === 3) {
                    setIssueMoreItem(true)
                  } else if (value === 2) {
                    setSubmitItem(true)
                  } else if (value === 4 || title === TITLE_ADD_PAYMENT) {
                    openEditItem(true)
                  }
                }}
                buttonTitle={emptyItemMap[value].buttonTitle}
                message={emptyItemMap[value].message}
              />
            )}

            {((value && value > 4) || (!emptyResult && !manageSlipsError && (manageSlipsLoading || (manageSlipsSuccess && data)))) && (
              <Box
                sx={{
                  position: 'sticky',
                  top: '148px',
                  zIndex: 998,
                  backgroundColor: 'white',
                  flexShrink: 0,
                }}
              >
                <AccountActionBar
                refr={ref}
                billInfo={data?.accountInfo}
                //value here is tab index
                showReceiveItems={true} //{value === 2 || value === 0}
                showAddEntry={true} //{value < 2}
                showAddPayment={value === 4}
                showCheckbox={value < 3}
                showBalanceItemsCheckbox={value === 3}
                screenType={selectScreenType}
                
                onViewPDF={() => {
                  if (value < 2) {
                    setShowMore(true)
                  } else {
                    handleViewPDF(false, null, null)
                  }
                }}
                onAddPayment={() => {
                  openEditItem(true)
                }}
                setTotalHidden={(hidden) => {
                  setChecked(hidden)
                }}
                setShowOnlyBalanceItems={(showOnly) => {
                  setBalanceItemsChecked(showOnly)
                }}
                selectTab={(index) => {
                  setValue(index)
                }}
              />
              </Box>
            )}
            <Popover
              open={showMore}
              anchorEl={ref.current}
              onClose={() => {
                setShowMore(false)
              }}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <List sx={{ p: 0 }} component="nav">
                {value < 2 && (
                  <>
                    <ListItem>
                      <Button
                        sx={{ fontWeight: 400 }}
                        startIcon={<PictureAsPdfIcon />}
                        onClick={() => {
                          setShowMore(false)
                          handleViewPDF(true, null)
                        }}
                      >
                        All Entries (With Rates)
                      </Button>
                    </ListItem>
                    <ListItem>
                      <Button
                        sx={{ fontWeight: 400 }}
                        startIcon={<PictureAsPdfIcon />}
                        onClick={() => {
                          setShowMore(false)
                          handleViewPDF(false, null)
                        }}
                      >
                        All Entries (Without Rates)
                      </Button>
                    </ListItem>
                  </>
                )}
                {value === 0 && (
                  <>
                    <ListItem>
                      <Button
                        sx={{ fontWeight: 400 }}
                        startIcon={<PictureAsPdfIcon />}
                        onClick={() => {
                          setShowMore(false)
                          dispatchAction(
                            getSiteChallansPDFAction({
                              billId: Number(bill_id),
                            })
                          )
                        }}
                      >
                        Rental Entries PDF
                      </Button>
                    </ListItem>
                    <ListItem>
                      <Button
                        sx={{ fontWeight: 400 }}
                        startIcon={<PictureAsPdfIcon />}
                        onClick={() => {
                          setShowMore(false)
                          dispatchAction(
                            getSiteChallansExcelAction({
                              billId: Number(bill_id),
                            })
                          )
                        }}
                      >
                        Rental Entries XLS
                      </Button>
                    </ListItem>
                  </>
                )}
              </List>
            </Popover>

            <Box
              sx={{
                width: '100%',
                mt: 0,
                flex: 1,
                minHeight: 0,
                overflowY: 'auto',
              }}
            >
              <Box
                sx={{
                  borderRadius: 1,
                }}
              ></Box>

              <>
                <TabPanel value={value} index={0}>
                  <AllItemComponent
                    data={
                      getslipDataToShow(searchTerm, searchResults, data)?.all
                    }
                    separatorHeight={Number(0.2)}
                    billId={Number(bill_id)}
                    onClickViewPDF={handleViewPDF}
                    screenType={selectScreenType}
                    billType={
                      data?.accountInfo ? data?.accountInfo.billType : ''
                    }
                    checked={checked}
                    account={data?.accountInfo}
                    onSlipsEntriesUpdated={silentRefreshSlips}
                  />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <OutItemComponent
                    data={
                      getslipDataToShow(searchTerm, searchResults, data)?.out
                    }
                    separatorHeight={0.2}
                    billId={Number(bill_id)}
                    onClickViewPDF={handleViewPDF}
                    screenType={selectScreenType}
                    billType={
                      data?.accountInfo ? data?.accountInfo.billType : ''
                    }
                    checked={checked}
                    account={data?.accountInfo}
                    onSlipsEntriesUpdated={silentRefreshSlips}
                  />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <InItemComponent
                    data={
                      getslipDataToShow(searchTerm, searchResults, data)?.in
                    }
                    separatorHeight={0.2}
                    billId={Number(bill_id)}
                    onClickViewPDF={handleViewPDF}
                    screenType={selectScreenType}
                    billType={
                      data?.accountInfo ? data?.accountInfo.billType : ''
                    }
                    checked={checked}
                    account={data?.accountInfo}
                    onSlipsEntriesUpdated={silentRefreshSlips}
                  />
                </TabPanel>
                <TabPanel value={value} index={3}>
                  <LeftItemComponent
                    data={
                      getslipDataToShow(searchTerm, searchResults, data)?.left
                    }
                    separatorHeight={0.2}
                    showOnlyBalanceItems={balanceItemsChecked}
                    account={data?.accountInfo}
                    slipResponse={data}
                  />
                </TabPanel>
                <TabPanel value={value} index={4}>
                  <PaymentItemComponent
                    data={data?.payment}
                    separatorHeight={0.2}
                    billId={Number(bill_id)}
                    screenType={selectScreenType}
                    accountType={data?.accountInfo?.accountType}
                    onSlipsEntriesUpdated={silentRefreshSlips}
                  />
                </TabPanel>
                <TabPanel value={value} index={5}>
                  <SiteRatesTab
                    siteId={Number(bill_id)}
                    onRatesUpdated={silentRefreshSlips}
                  />
                </TabPanel>
                <TabPanel value={value} index={6}>
                  <MonthlyBills bill={data.accountInfo} />
                </TabPanel>
                <TabPanel value={value} index={7}>
                  <Ledger bill={data.accountInfo} />
                </TabPanel>
                <TabPanel value={value} index={8}>
                  {data?.accountInfo ? (
                    <EditSiteView
                      siteBill={data.accountInfo}
                      billId={Number(bill_id)}
                      onSlipsEntriesRefresh={silentRefreshSlips}
                    />
                  ) : null}
                </TabPanel>
                {canViewSiteActivities && (
                  <TabPanel value={value} index={9}>
                    <SiteActivitiesTab accountId={Number(bill_id)} />
                  </TabPanel>
                )}
              </>
            </Box>
          </Grid>
        </Grid>
        {editItem && (
          <AddEditPaymentItem
            item={addPaymentRequest}
            accountType={data?.accountInfo?.accountType}
            onClose={() => {
              openEditItem(false)
            }}
            onSubmitSuccess={() => {
              openEditItem(false)
            }}
          />
        )}
        {issueMoreItem && (
          <IssueMoreItem
            bill_id={+bill_id}
            customer_id={+customer_id}
            onClose={() => setIssueMoreItem(false)}
            billType={data.accountInfo.billType}
            billInfo={data.accountInfo}
          />
        )}
        {submitItem && (
          <SubmitItem
            bill_id={+bill_id}
            customer_id={+customer_id}
            onClose={() => setSubmitItem(false)}
            billType={data.accountInfo.billType}
            bill={data.accountInfo}
          />
        )}
        {editSiteDialogOpen && data?.accountInfo && (
          <AddAccountItem
            onClose={() => setEditSiteDialogOpen(false)}
            partialBill={data.accountInfo}
            onSlipsEntriesRefresh={silentRefreshSlips}
          />
        )}
      </PageContainerWrapper>
      </>
    </SlipsOpenEditSiteContext.Provider>
  )
}

export default ViewSlips
